import isNil from 'lodash/isNil';
import {
  EventKind,
  IEventConditionFieldsFragment,
  IEventInput,
} from '../apollo/graphqlSchema';
import { MaybeNil } from '../interfaces';
import { byTypeName } from '../types';

export const defaultEventInput: IEventInput = {
  kind: EventKind.Any,
  basicEventName: null,
  virtualEventId: null,
  anyTableEventKey: null,
};

/**
 * Function that checks that event condition includes events
 * @param eventCondition
 * @returns True: if the eventCondition is empty
 *          False: not empty
 */
export const isEmptyEventCondition = (
  eventCondition: MaybeNil<IEventConditionFieldsFragment>,
): boolean => {
  if (isNil(eventCondition)) {
    return true;
  }

  const events = eventCondition.events;
  const anyEvent = events.filter(byTypeName('AnyEvent'));
  const basicEvents = events.filter(byTypeName('BasicEventValue'));
  const virtualEvents = events.filter(byTypeName('VirtualEvent'));
  const anyTableEvents = events.filter(byTypeName('AnyTableEvent'));
  return (
    !anyEvent?.length &&
    !basicEvents?.length &&
    !virtualEvents?.length &&
    !anyTableEvents?.length
  );
};

/**
 * Checking every event condition in the list.
 * @param eventConditions
 * @returns true: if eventCondition has all empty events
 *          false: if not valid input or events is not empty in eventCondition
 */
export const isEmptyEventConditions = (
  eventConditions: IEventConditionFieldsFragment[] | undefined,
) => {
  if (!eventConditions || eventConditions.length === 0) {
    return false;
  }
  return eventConditions.every((eventCondition) =>
    isEmptyEventCondition(eventCondition),
  );
};
